import { type ReactNode } from 'react';
import { Alert, Heading, Text } from '@launchpad-ui/components';

import styles from './SdkActiveAlert.module.css';

type SdkActiveAlertProps = {
  status: 'error' | 'warning';
  title: string;
  onTryAgain: () => void;
  onContactSupport: () => void;
  className?: string;
  children?: ReactNode;
};

export const SdkActiveAlert = ({
  status,
  title,
  onTryAgain,
  onContactSupport,
  className,
  children,
}: SdkActiveAlertProps) => (
  <Alert className={className} status={status}>
    <Heading slot="title">{title}</Heading>
    <Text slot="subtitle">
      <button type="button" onClick={onTryAgain} className={styles.linkButton}>
        Try again
      </button>{' '}
      or{' '}
      <button type="button" onClick={onContactSupport} className={styles.linkButton}>
        contact Support
      </button>
      .{children}
    </Text>
  </Alert>
);
